import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqid from 'uniqid';
import { Modal, Tabs, TabList, Tab } from '@bwoty-web/ui-kit';
import SectionParagraph from '../../../common/sectionParagraph';

import './tileContent.scss';

const TileContent = ({ tile, isExpanded = false, close }) => {
  const [selectedTile, setSelectedTile] = useState(0);

  const tabOptions = tile?.content?.map((contentPart) => {
    return contentPart?.heading;
  });
  const classes = classNames('tile-popup', `tile-popup-${tile?.key}`);
  return (
    <Modal
      className={classes}
      isOpen={isExpanded}
      size="m"
      onClose={() => close(tile?.key)}
      heading={tile?.header}
    >
      <Tabs
        onChange={(index) => setSelectedTile(index)}
        selectedIndex={selectedTile}
      >
        {tabOptions?.length > 1 && (
          <TabList fullWidth className="tile-popup-tab-list">
            {tabOptions?.map((heading) => (
              <Tab key={uniqid('tab-option-')}>{heading}</Tab>
            ))}
          </TabList>
        )}
      </Tabs>
      <div className="tile-popup-content-container">
        {tile?.content?.map((contentPart, index) => {
          const contentGroupclasses = classNames({
            'tile-content-group': true,
            'tile-content-group--active': index === selectedTile,
          });

          const destinationParagraphs = contentPart?.paragraphs?.filter(
            (paragraph) => paragraph?.id === 'fromDestination',
          );

          const resortParagraphs = contentPart?.paragraphs?.filter(
            (paragraph) => paragraph?.id !== 'fromDestination',
          );

          return (
            <div className={contentGroupclasses} key={uniqid('content-group-')}>
              {resortParagraphs?.map((paragraph) => {
                return (
                  <SectionParagraph
                    paragraph={paragraph}
                    key={uniqid('resort-paragraph-')}
                  />
                );
              })}
              {isExpanded &&
                destinationParagraphs?.map((paragraph) => {
                  return (
                    <SectionParagraph
                      paragraph={paragraph}
                      key={uniqid('destination-paragraph-')}
                    />
                  );
                })}
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

TileContent.propTypes = {
  tile: PropTypes.shape({
    header: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({}),
    ]),
    key: PropTypes.string,
  }).isRequired,
  isExpanded: PropTypes.bool,
  close: PropTypes.func.isRequired,
};

export default TileContent;
